import {EBook} from "./eLibrarySlice";
import {toggleLoader} from "../global/globalSlice";
import {AxiosInstance} from "../../api/axiosInstance";
import {Dispatch} from "react";

export const downloadBook = (eBook: EBook, dispatch: Dispatch<any>) => {
  dispatch(toggleLoader(true));
  AxiosInstance({
    url: eBook.downloadUrl, //your url
    method: 'GET',
    responseType: 'blob', // important
  })
    .then((response) => {
      // create file link in browser's memory
      const href = URL.createObjectURL(response.data);

      // create "a" HTML element with href to file & click
      const link = document.createElement('a');
      link.href = href;
      link.setAttribute('download', eBook.title); //or any other extension
      document.body.appendChild(link);
      link.click();

      // clean up "a" element & remove ObjectURL
      document.body.removeChild(link);
      URL.revokeObjectURL(href);
      dispatch(toggleLoader(false));
    })
    .catch((error) => {
      console.log("download error", error);
      dispatch(toggleLoader(false));
    });
}